
import Database from  "@/database";

var pouch_db = {}


function localPouchDb(project) {
   if (!pouch_db[project]) {
     pouch_db[project] = new Database(project)
   }
   return pouch_db[project]
}
  

export { localPouchDb }